module.exports = __webpack_public_path__ + "img/int-class.07ff7601.jpeg";